import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import * as S from "./styled.js";
const DateBlog = ({ beforeText , day , month  })=>/*#__PURE__*/ _jsxs(S.MobileBlogItemDate, {
        children: [
            beforeText,
            /*#__PURE__*/ _jsxs(S.MobileBlogItemDay, {
                children: [
                    " ",
                    day,
                    " "
                ]
            }),
            /*#__PURE__*/ _jsxs(S.MobileBlogItemMonth, {
                children: [
                    " ",
                    month,
                    " "
                ]
            })
        ]
    });
export const BlogItem = (props)=>{
    const { title , link , date , image , featured , config , ...rest } = props;
    const size = featured ? {
        width: 450,
        height: 120
    } : {
        width: 120,
        height: 120
    };
    return /*#__PURE__*/ _jsx(S.MobileBlogItemContainer, {
        "data-testid": "BlogItem",
        className: classNames('blog-item__container', {
            'blog-item__container--featured': featured
        }),
        ...rest,
        children: /*#__PURE__*/ _jsxs(S.MobileBlogItemMain, {
            children: [
                /*#__PURE__*/ _jsxs(S.MobileBlogItemMainLink, {
                    href: link.href,
                    title: title,
                    target: link.target,
                    children: [
                        !!featured && /*#__PURE__*/ _jsx(DateBlog, {
                            ...date
                        }),
                        /*#__PURE__*/ _jsx(S.MobileBlogItemImage, {
                            ...image,
                            resize: size,
                            ...size,
                            isLazy: true
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(S.MobileBlogItemContent, {
                    children: /*#__PURE__*/ _jsx(S.MobileBlogItemContentLink, {
                        href: link.href,
                        title: title,
                        target: link.target,
                        children: /*#__PURE__*/ _jsxs(S.MobileBlogItemBlock, {
                            children: [
                                /*#__PURE__*/ _jsx(S.MobileBlogItemTitle, {
                                    children: title
                                }),
                                !featured && /*#__PURE__*/ _jsx(DateBlog, {
                                    ...date,
                                    ...props,
                                    beforeText: config?.literals?.published
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
export default BlogItem;

//# sourceMappingURL=index.js.map